export default __webpack_public_path__ + "static/media/bbamUSDT.8e6899f7.png";